/*
Resize iframe when resize message is posted from the base origin
*/
import Sb from "../abstract/StatefulBehavior";
import urlParse from "url-parse";

export default class ResizeIframe extends Sb {
  constructor(el, props) {
    super();

    this.state = {
      iframeLoaded: false,
      height: 0,
    };

    this.props = props;
    this.iframe = el;

    if (!this.iframe.src) return null;
    this.baseUrlOrigin = urlParse(this.iframe.src).origin;

    this.bindEvents();
  }

  get scriptSrc() {
    return `${this.props.baseurl}/scripts/integrate.js`;
  }

  bindEvents() {
    if (window.addEventListener) {
      window.addEventListener("message", this.handleMessage, false);
    } else {
      window.attachEvent("onmessage", this.handleMessage);
    }
  }

  update = () => {
    const { height } = this.state;

    if (!this.iframe) return;

    Object.assign(this.iframe.style, {
      height: `${height}px`,
    });
  };

  scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  handleMessage = ({ data, origin }) => {
    if (this.baseUrlOrigin !== origin || !data?.[0]) return;

    if (data[0] === "resize") {
      this.setState({ height: data[1] });
      return;
    }

    if (data[0] === "scrollToTop") {
      this.scrollToTop();
    }
  };
}
